import React from 'react';
import { Navigate } from 'react-router-dom';
import DashboardLayout from 'src/layouts/DashboardLayout';
import MainLayout from 'src/layouts/MainLayout';
import AccountView from 'src/views/account/AccountView';
import LoginView from 'src/views/auth/LoginView';
import LoginFacebook from 'src/views/auth/LoginFacebook';
import LoginMicrosoft from 'src/views/auth/LoginMicrosoft';
import LoginGoogle from 'src/views/auth/LoginGoogle';
import NotFoundView from 'src/views/errors/NotFoundView';
import ProductListView from 'src/views/product/ProductListView';
import AllImagesView from 'src/views/product/AllImagesView';
import SettingsView from 'src/views/settings/SettingsView';
import ContactView from './views/contact/ContactView';
import HelpView from './views/help/HelpView';
import PrivacyPolicyView from './views/legal/PrivacyPolicyView';
import TermsView from './views/legal/TermsView';

const routes = (isLoggedIn) => {
  return [
    { path: '/privacy-policy', element: <PrivacyPolicyView /> },
    { path: '/terms', element: <TermsView /> },
    {
      path: 'app',
      element: isLoggedIn ? <DashboardLayout /> : <Navigate to='/app/login'/>,
      children: [
        { path: 'dashboard', element: <ProductListView /> },
        { path: 'dashboard/:groupId/:categoryId', element: <ProductListView /> },
        { path: 'all-images', element: <AllImagesView /> },
        { path: 'account', element: <AccountView /> },
        { path: 'contact', element: <ContactView /> },
        { path: 'help', element: <HelpView /> },
        { path: 'settings', element: <SettingsView /> },
        { path: '', element: <Navigate to="/app/dashboard" /> },
        { path: '*', element: <Navigate to="/404" /> },
      ]
    },
    // {
    //   path: '/share/:token/:filename',
    //   element: <ShareProductView />,
    // },
    {
      path: '/',
      element: !isLoggedIn ? <MainLayout /> : <Navigate to='/app/dashboard'/>,
      children: [
        { path: '/app/login-facebook', element: <LoginFacebook /> },
        { path: '/app/login-microsoft', element: <LoginMicrosoft /> },
        { path: '/app/login-google', element: <LoginGoogle /> },
        { path: '/app/login', element: <LoginView /> },
        { path: '404', element: <NotFoundView /> },
        { path: '/', element: <Navigate to="/app/dashboard" /> },
        { path: '*', element: <Navigate to="/404" /> }
      ]
    }
  ];
};

export default routes;
